import { SxProps, TextField, TextFieldProps, Theme } from '@mui/material';

interface CustomTextFieldProps extends Omit<TextFieldProps, 'sx'> {
  sx?: SxProps<Theme>;
}

export function CustomTextField({ sx, InputProps, ...props }: CustomTextFieldProps) {
  return (
    <TextField
      variant="outlined"
      fullWidth
      InputProps={{
        sx: {
          padding: '8px 12px',
          minHeight: '44px',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '28px',
          backgroundColor: '#ffffff',
          border: '1px solid #DDE1E6',
          borderRadius: '6px',
          boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08)',
          '& fieldset': {
            border: 'none !important',
          },
          '&:hover fieldset': {
            border: 'none !important',
          },
          '&.Mui-focused fieldset': {
            border: 'none !important',
            boxShadow: 'none !important',
          },
          '&.Mui-focused': {
            border: '1px solid #AF52DE !important',
            boxShadow:
              '0px 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 2px rgba(175, 82, 222, 0.1) !important',
          },
        },
        ...InputProps,
      }}
      inputProps={{
        sx: {
          padding: 0,
        },
      }}
      sx={sx}
      {...props}
    />
  );
}
